import { IUserSlice, IUserState, SetUserPayload } from './userSlice.interface';
import { availableLanguagesObj, ILanguage } from '../../config/i18n/common';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SetBooleanPayload, SetStringPayload } from '../../interfaces/store.interface';
import { SetCurrentLanguagePayload } from '../core/coreSlice.interface';
import { ILoggedInUser } from '../../interfaces/auth.interface';

const initialState: IUserState = {
  loading: false,
  user: null,
  countryCode: '+30',
  currentLanguage: availableLanguagesObj.el,
  langLoading: false,
  logoutLoading: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserLoading: (state: IUserState, action: PayloadAction<SetBooleanPayload>): void => {
      state.loading = action.payload.value;
    },
    setLangLoading: (state: IUserState, action: PayloadAction<SetBooleanPayload>): void => {
      state.langLoading = action.payload.value;
    },
    setLogoutLoading: (state: IUserState, action: PayloadAction<SetBooleanPayload>): void => {
      state.logoutLoading = action.payload.value;
    },
    setUser: (state: IUserState, action: PayloadAction<SetUserPayload>): void => {
      state.user = action.payload.user;
    },
    setCountryCode: (state: IUserState, action: PayloadAction<SetStringPayload>): void => {
      state.countryCode = action.payload.value;
    },
    setCurrentLanguage: (state: IUserState, action: PayloadAction<SetCurrentLanguagePayload>): void => {
      state.currentLanguage = action.payload.currentLanguage;
    },
  },
});

//////////////////////////////// ACTIONS ////////////////////////////////
export const { setUser, setCountryCode, setCurrentLanguage, setLangLoading, setUserLoading, setLogoutLoading } =
  userSlice.actions;

//////////////////////////////// SELECTORS ////////////////////////////////
export const selectUserLoading = (state: IUserSlice): boolean => state.user.loading;
export const selectLogoutLoading = (state: IUserSlice): boolean => state.user.logoutLoading;
export const selectLangLoading = (state: IUserSlice): boolean => state.user.langLoading;
export const selectCurrentLanguage = (state: IUserSlice): ILanguage => state.user.currentLanguage;
export const selectShowMainNav = (state: IUserSlice): boolean => !!state.user.user;
export const selectUser = (state: IUserSlice): ILoggedInUser | null => state.user.user;
export const selectUserFullName = (state: IUserSlice): string =>
  `${state.user.user?.user?.lastName} ${state.user.user?.user?.firstName}`;
export const selectIsSuperuser = (state: IUserSlice): boolean | undefined | null => state.user.user?.user?.isSuperuser;
export const selectUserIsLoggedIn = (state: IUserSlice): boolean => !!state.user.user;
export const selectCountryCode = (state: IUserSlice): string => state.user.countryCode;

export default userSlice.reducer;
